import React from "react";

const SelectList = ({
  list,
  title,
  selecteditems,
  onChange,
  selectionType = "checkbox",
  listStyle = "line",
  paddingRequired = true,
}) => {
  return (
    <div>
      <div className={paddingRequired ? "px-10" : ""}>
        {title && (
          <>
            <h4 className="text-2xl font-semibold">{title}</h4>
            <hr className="my-4" />
          </>
        )}
        {/* Checkbox List */}
        {selectionType === "checkbox" && (
          <div className="space-y-6">
            {list.map((item, index) => (
              <div
                key={index}
                className={
                  listStyle === "line"
                    ? `flex justify-between items-center border-b pb-4`
                    : `flex justify-between items-center border py-4 rounded-lg`

                }
                
              >
                <label className="text-sm px-8 font-light">{item.label}</label>
                <input
                  type="checkbox"
                  checked={selecteditems.includes(item.value)}
                  onChange={() => onChange(item.value)}
                  className="w-5 h-5 accent-white border-2 border-gray-400 focus:border-black cursor-pointer mx-6"
                />
              </div>
            ))}
          </div>
        )}

        {/* Number Input List */}
        {selectionType === "number" && (
          <div className="space-y-6">
            {list.map((item) => (
              
              <div
                key={item.value}
                className="flex justify-between items-center border-b pb-4"
              >
                <label className="text-sm px-8 font-light">{item.label}</label>
                <input
                  type="number"
                  min="0"
                  max={"20000"}
                  value={selecteditems[item.value]}
                  placeholder={0}
                  onChange={(e) => onChange(e.target.value, item.value)}
                  className="border rounded-md px-2 cursor-pointer mx-6"
                />
              </div>
            ))}
          </div>
        )}

        {/* Styled Radio Buttons like Checkboxes */}
        {selectionType === "radio" && (
          <div className="space-y-6">
            {list.map((item) => (
              <div
                key={item.value}
                className="flex justify-between items-center border-b pb-4"
              >
                <label className="text-sm px-8 font-light">{item.label}</label>
                <div className="relative">
                  <input
                    type="radio"
                    name={title} // Ensures only one option is selected per category
                    value={item.value}
                    checked={selecteditems === item.value}
                    onChange={() => onChange(item.value)}
                    className="appearance-none w-5 h-5 border-2 border-gray-400 rounded-md cursor-pointer peer"
                  />
                  {/* Custom Checkbox-like Checkmark */}
                  {selecteditems === item.value && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white rounded-md">
                      <span className="text-[#000] font-bold text-sm">✓</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectList;
